export const SIGN_UP_CARD_TITLE = 'Join 1,000,000+ podcasters';
